import { Reveal, ClipReveal, Tag, LineReveal, ArrowLink } from "../components/Shared";
import { IMAGES } from "../data/content";

const Designer = () => (
  <section className="relative overflow-hidden bg-coal px-5 py-28 sm:px-10 md:py-44" data-testid="designer-section">
    <div className="pointer-events-none absolute inset-x-0 bottom-0 select-none text-center font-serif text-[18vw] font-light leading-none text-bone/[0.05]">BHONSLE</div>
    <div className="mx-auto grid max-w-[1600px] items-center gap-16 lg:grid-cols-2 lg:gap-24">
      <div className="relative order-2 lg:order-1">
        <ClipReveal src={IMAGES.designer} alt="Rutu Bhonsle at work in the atelier — every stitch has a story" className="aspect-[4/5]" imgClassName="object-[62%_center]" />
        <Reveal delay={0.4} className="absolute -right-4 bottom-10 border border-flame/40 bg-ink px-6 py-4 sm:-right-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-flame">From sketch to silhouette</p>
        </Reveal>
      </div>
      <div className="order-1 lg:order-2">
        <Reveal><Tag>The Designer</Tag></Reveal>
        <LineReveal lines={["RUTU", "BHONSLE"]} className="mt-6 font-serif text-6xl font-light leading-[0.95] tracking-tight sm:text-8xl" />
        <Reveal delay={0.25}>
          <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.35em] text-flame">Designer. Creator. Storyteller.</p>
        </Reveal>
        <Reveal delay={0.35}>
          <blockquote className="mt-10 border-l-2 border-flame pl-6 font-serif text-2xl font-light italic leading-snug text-bone/90" data-testid="designer-quote">
            “Fashion is not simply what we wear. It is how we enter a room, how we carry ourselves, and how we choose to be remembered.”
          </blockquote>
        </Reveal>
        <Reveal delay={0.45}>
          <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-fog">
            From Nagpur to the runways of New York Fashion Week, the house has built a language of
            innovative prints, inclusive silhouettes and classic styles — a distinctly Indian voice
            with a global fashion vocabulary.
          </p>
        </Reveal>
        <Reveal delay={0.55} className="mt-10">
          <ArrowLink to="/designer" testId="read-the-story-link" big>Read the Story</ArrowLink>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Designer;
